import axiosAgent from './axiosAgent';
import Apiconfig from '../config/ApiConfig';

export const changeLogo = async (path) => {
    try {
        const response = await axiosAgent.post(Apiconfig.ui.changeLogo, path);
        return response;
    } catch (err) {
        return err.message;
    }
};

export const getLogo = async () => {
    try {
        const response = await axiosAgent.get(Apiconfig.ui.getLogo);
        return response;
    } catch (err) {
        return null;
    }
};
